import { useAtomValue } from 'jotai'
import React from 'react'

import { type NineSegment } from '~/utils'

import { isPercentageAtom } from '../../atoms'
import { useBrandSeries } from '../../hooks/useBrandSeries'
import { useCategories } from '../../hooks/useCategories'

import { TimeSeriesChart, type TimeSeriesChartProps } from './TimeSeriesChart'

export type DistributionChartProps = {
  nineSegment: NineSegment
}

export const DistributionChart = ({ nineSegment }: DistributionChartProps) => {
  const categories = useCategories()

  const isPercentage = useAtomValue(isPercentageAtom)
  const chartType = React.useMemo<TimeSeriesChartProps['chartType']>(
    () => (isPercentage ? 'line' : 'column'),
    [isPercentage],
  )

  const series = useBrandSeries(nineSegment)

  return (
    <TimeSeriesChart
      categories={categories}
      chartType={chartType}
      isPercentage={isPercentage}
      series={series}
    />
  )
}
